import { colors } from '../../Colors/colors'

export const permissionsTheme = {
   light: {},
   dark: {}
}
